export default __webpack_public_path__ + "static/media/logos_whatsapp.15df0d79.svg";